export class AllocationViewFilterProfileListLoad {
  public static readonly type = '[AllocationViewFilterProfileList] List load';
}

export class AllocationViewFilterProfileListInitialState {
  public static readonly type = '[AllocationViewFilterProfileList] Set Initial State';
}
